import {Component, Input} from '@angular/core';
import {ConfigMap} from '../templating-config-map/templating-config-map.component';
import {UtilsService} from '../../../shared/services/utils.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-templating-config-fields',
  templateUrl: './templating-config-fields.component.html',
  styleUrls: ['./templating-config-fields.component.scss']
})
export class TemplatingConfigFieldsComponent {
  @Input() configMap: ConfigMap;
  @Input() rootPrefix: string;

  constructor(
    private utils: UtilsService,
    private snack: MatSnackBar,
  ) {
  }

  copy(val: string): void {
    this.utils.copyToClipboard(val);
    this.snack.open(`Skopiowano "${val}" do schowka`, '', {duration: 2000});
  }
}
